/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Coverage amount for motor vehicle liability.   (german: Deckungsart in der Kfz Haftpflicht)   (bipro-kraftfahrt::DeckungsartKHBasis)     * `Total_100000000_Person_8000000`    - 100.000.000 Euro (pauschal),  8.000.000 Euro maximal pro Person   * `Total_100000000_Person_10000000`   - 100.000.000 Euro (pauschal), 10.000.000 Euro maximal pro Person   * `Total_100000000_Person_12000000`   - 100.000.000 Euro (pauschal), 12.000.000 Euro maximal pro Person   * `Total_100000000_Person_14000000`   - 100.000.000 Euro (pauschal), 14.000.000 Euro maximal pro Person   * `Total_100000000_Person_15000000`   - 100.000.000 Euro (pauschal), 15.000.000 Euro maximal pro Person   * `Total_100000000_Person_16000000`   - 100.000.000 Euro (pauschal), 16.000.000 Euro maximal pro Person
 */
export const CoverageAmountMotorVehicleLiability = {
  Total100000000Person8000000: 'Total_100000000_Person_8000000',
  Total100000000Person10000000: 'Total_100000000_Person_10000000',
  Total100000000Person12000000: 'Total_100000000_Person_12000000',
  Total100000000Person14000000: 'Total_100000000_Person_14000000',
  Total100000000Person15000000: 'Total_100000000_Person_15000000',
  Total100000000Person16000000: 'Total_100000000_Person_16000000',
} as const;
export type CoverageAmountMotorVehicleLiability =
  (typeof CoverageAmountMotorVehicleLiability)[keyof typeof CoverageAmountMotorVehicleLiability];
